import {FC, ReactNode} from 'react';

import {Box, SxProps} from '@mui/material';

import {empionOrange} from '../../../../../layouts/theme/EmpionColors';

interface Props {
  children: ReactNode;
  sx?: SxProps;
}

// Surveys-style section card. Sections historically used large top margins
// (e.g. mt:10 / 45px) on their inner `Editable` wrapper for spacing. Inside a
// card those margins create awkward gaps, so we neutralize the leading
// top-margin of the wrapped section (and its first child, to cover the
// `Box > Editable` shape used by Settings/LeadershipExperience).
export const ProfileSectionCard: FC<Props> = ({children, sx}) => (
  <Box
    sx={{
      backgroundColor: '#fff',
      border: `1px solid ${empionOrange[3]}`,
      borderRadius: '16px',
      p: {xs: 2, sm: 3},
      '& > *:first-of-type, & > *:first-of-type > *:first-of-type': {
        mt: 0,
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);
